import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  image: string;
  date: string;
  views: number;
  tags: string[];
  categoryName?: string;
  categorySlug?: string;
}

export default function ArticleCard({
  slug,
  title,
  excerpt,
  image,
  date,
  views,
  tags,
  categoryName,
  categorySlug,
}: ArticleCardProps) {
  return (
    <article className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer">
      <Link to={`/article/${slug}`} className="block">
        <div className="relative aspect-[16/9] overflow-hidden">
          <img
            src={image}
            alt={title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
          {categoryName && (
            <span className="absolute top-3 left-3 bg-primary-500 text-white text-xs px-2 py-1 rounded-md">
              {categoryName}
            </span>
          )}
        </div>
      </Link>
      <div className="p-4">
        <Link to={`/article/${slug}`} className="block cursor-pointer">
          <h3 className="font-heading text-base text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-500 transition-colors duration-200 mb-2">
            {title}
          </h3>
        </Link>
        <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed mb-3">
          {excerpt}
        </p>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3 text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-calendar-line w-3.5 h-3.5 flex items-center justify-center"></i>
              {date}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-eye-line w-3.5 h-3.5 flex items-center justify-center"></i>
              {views >= 10000 ? `${(views / 10000).toFixed(1)}万` : views}
            </span>
          </div>
          {categorySlug && (
            <Link
              to={`/category/${categorySlug}`}
              className="text-xs text-primary-500 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              查看分类
            </Link>
          )}
        </div>
        {tags.length > 0 && (
          <div className="flex flex-wrap gap-1.5 mt-3">
            {tags.slice(0, 3).map((tag) => (
              <span
                key={tag}
                className="text-xs bg-secondary-100 text-secondary-700 px-2 py-0.5 rounded-full"
              >
                {tag}
              </span>
            ))}
          </div>
        )}
      </div>
    </article>
  );
}